<script lang="ts" setup>
import type { Ref, PropType } from 'vue';
import { computed, isRef } from 'vue';
import type { ICellRendererParams } from 'ag-grid-community';

/**********
 * Init
 **********/
type ExtendedParams = ICellRendererParams & {
    id: string;
    title: Ref<string> | string;
    variant?: Ref<string> | string;
    cssClasses: Ref<string> | string;
    loading?: Ref<boolean> | boolean;
    icon: Ref<string> | string;
    click: () => void;
    disabled?: Ref<boolean> | boolean;
};

const props = defineProps({
    params: {
        type: Object as PropType<ExtendedParams>,
        required: true
    }
});

const title = computed(() => {
    if (props.params.title === undefined) return '';
    return isRef(props.params.title) ? props.params.title.value : props.params.title;
});
const loading = computed(() => {
    if (props.params.loading === undefined) return false;
    return isRef(props.params.loading) ? props.params.loading.value : props.params.loading;
});
const variant = computed(() => {
    if (props.params.variant === undefined) return '';
    return isRef(props.params.variant) ? props.params.variant.value : props.params.variant;
});
const click = computed(() => props.params.click);
const disabled = computed(() => {
    if (props.params.disabled === undefined) return false;
    return isRef(props.params.disabled) ? props.params.disabled.value : props.params.disabled;
});

</script>
<template>
    <button
        :class="['button small padding-horizontal-5', variant, loading ? 'padding-vertical-2' : 'padding-vertical-3']"
        :disabled="disabled"
        @click="click()"
    >
        <Icon
            v-if="loading"
            icon="loader-2"
            class="sy-spin"
        />
        <span v-else>{{ title }}</span>
    </button>
</template>
